// material-ui
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

// ==============================|| PAGE LOADER ||============================== //
//
// Gentle, centred loader used as the route Suspense fallback (and reusable for
// in-page data fetches) so navigating to a page shows a spinner in the content
// area instead of a blank white screen while its chunk / data loads.

const PageLoader = ({ message = 'Loading…', minHeight = '60vh' }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight,
    }}
  >
    <Stack spacing={1.5} alignItems="center">
      <CircularProgress color="primary" />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Stack>
  </Box>
);

export default PageLoader;
